const universeStorageKey = 'universe-sid'
const universeEnvironmentKey = 'universe-env'

export default {
    setUniverseToken(token) {
        sessionStorage.setItem(universeStorageKey, token)
    },
    removeUniverseToken() {
        sessionStorage.removeItem(universeStorageKey)
    },
    getUniverseToken(){
        return sessionStorage.getItem(universeStorageKey)
    },
    setUniverseEnvironment(environment) {
        localStorage.setItem(universeEnvironmentKey, environment)
    },
    removeUniverseEnvironment() {
        localStorage.removeItem(universeEnvironmentKey)
    },
    getUniverseEnvironment(){
        return localStorage.getItem(universeEnvironmentKey);
    }
}